import React from 'react'
import Footer from '../footer/Footer'
import { InfoAboutMe } from '../infoAboutMe/InfoAboutMe'
import ProjectsArea from '../main/projects-area/ProjectsArea'
import { SkillsArea } from '../main/skills-area/SkillsArea'
import { Navbar } from '../navbar/Navbar'
import { MainContainer } from './styles'

export const PortfolioApp = () => {
  return (
    <MainContainer>
      <Navbar />
      <InfoAboutMe />
      <SkillsArea />
      <ProjectsArea />
      <Footer name='Pablo Hernandez'/>
    </MainContainer>
  )
}
